import React, { useRef, useState } from 'react';
import { AnimatePresence, motion, useInView } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { useEscaCopy } from '../../i18n/escaCopy';
const EASE = [0.23, 1, 0.32, 1] as const;
export function EscaFaqSection() {
  const {
    lang
  } = useLanguage();
  const c = useEscaCopy(lang);
  const [open, setOpen] = useState<number | null>(null);
  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="faq" className="bg-sand py-20 lg:py-28" ref={ref} data-id="element-269" data-mp="1ouwyxgu8c0ep">
      <div className="max-w-[88rem] mx-auto px-5 sm:px-8" data-id="element-270" data-mp="22n35qcbhsv1h">
        <div className="grid lg:grid-cols-[minmax(0,20rem)_1fr] gap-10 lg:gap-20" data-id="element-271" data-mp="1xpl0ox0lizyr">
          <motion.h2 initial={{
          opacity: 0,
          y: 16
        }} animate={inView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.55,
          ease: EASE
        }} className="esca-h2 text-ink" data-id="element-272" data-mp="2cmllegkddunq">
            {c.faq.title}
          </motion.h2>

          <motion.dl initial={{
          opacity: 0,
          y: 16
        }} animate={inView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.55,
          delay: 0.1,
          ease: EASE
        }} className="border-t border-line" data-id="element-273" data-mp="v0dlff2fhkf8">
            {c.faq.items.map((item, i) => {
            const isOpen = open === i;
            return <div key={item.q} className="border-b border-line" data-id="element-274" data-mp="1dw3oz6q0eov8" data-mpi={i}>
                  <dt data-id="element-275" data-mp="1ivztr86j6kbu">
                    <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="w-full flex items-start justify-between gap-6 py-5 lg:py-6 text-left" data-id="element-276" data-mp="1ivgcltopfzyv">
                      <span className="font-display text-[1.0625rem] lg:text-xl font-semibold text-ink tracking-[-0.02em] leading-snug" data-id="element-277" data-mp="1wopezae8jl7w">
                        {item.q}
                      </span>
                      <PlusIcon className={`flex-shrink-0 w-5 h-5 mt-0.5 text-accent transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} data-id="element-278" data-mp="1ljat9f3tsxz" />
                    </button>
                  </dt>
                  <AnimatePresence initial={false} data-id="element-279" data-mp="6iswcdzdhkgj">
                    {isOpen && <motion.dd initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.25,
                  ease: EASE
                }} className="overflow-hidden" data-id="element-280" data-mp="ka7phdmzv21b">
                        <p className="pb-6 pr-12 text-[1.0625rem] text-muted leading-relaxed max-w-[62ch]" data-id="element-281" data-mp="2w0igkyyx0rd7">
                          {item.a}
                        </p>
                      </motion.dd>}
                  </AnimatePresence>
                </div>;
          })}
          </motion.dl>
        </div>
      </div>
    </section>;
}